import { createContext } from 'react'
import { IdToken } from '@auth0/auth0-react'

export type IdTokenContextValue = IdToken | null

export const IdTokenContext = createContext<IdTokenContextValue>(null)
